import {faCaretDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * Displays the TM tape
 * @param tape {string[]} content of the tape
 * @param highlightedCellIndex {number} index of TM head in the tape
 * @param emptyCellChar {string}
 * @param needToHighlight {boolean} highlight or not the <code>highlightedCellIndex</code>
 * @constructor
 */
export default function TapeComponent({tape, highlightedCellIndex, emptyCellChar, needToHighlight}) {
    const MIN_NUMBER_OF_CELLS = 51; // sufficient for pretty displaying


    // conditions for successful pretty displaying of tape:
    // - at least MIN_NUMBER_OF_CELLS of tape cells
    // - number of cell must be odd (to center highlightedCell)
    // - highlightedCell must be in the center of the tape
    // if one of conditions is not satisfied, tape array will be adjusted

    /**
     *
     * @param tape {string[]}
     * @param highlightedCellIndex {number}
     * @param emptyCellChar {string}
     * @returns {[string[], number]} [newTape, newHighlightedCellIndex]
     */
    const adjustTapeForDisplaying = (tape, highlightedCellIndex, emptyCellChar) => {
        let newTape = [...tape];
        let newHighlightedCellIndex = highlightedCellIndex;

        let leftTail = newHighlightedCellIndex;
        let rightTail = tape.length - 1 - leftTail;

        // center highlightedCell
        if(leftTail > rightTail) {
            newTape.push(...Array(leftTail - rightTail).fill(emptyCellChar));
        }
        else if(leftTail < rightTail) {
            newTape.unshift(...Array(rightTail - leftTail).fill(emptyCellChar));
            newHighlightedCellIndex += rightTail - leftTail;
        }
        // else highlightedCell is already in the center
        // here, newTape.length is guaranteed to be odd (2 * tailLength + 1)

        // adjust newTape at least the size of MIN_NUMBER_OF_CELLS
        while(newTape.length < MIN_NUMBER_OF_CELLS) {
            newTape.unshift(emptyCellChar);
            newTape.push(emptyCellChar);
            newHighlightedCellIndex++;
        }

        return [newTape, newHighlightedCellIndex];
    }


    let [adjustedTape, adjustedHighlightedCellIndex]
        = adjustTapeForDisplaying(tape, highlightedCellIndex, emptyCellChar);

    return (
        <div className="d-flex flex-column">
            {/* TM head */}
            <div className={(needToHighlight)
                ? 'd-flex flex-row justify-content-center tape-tm-head'
                : 'd-flex flex-row justify-content-center tape-tm-head text-muted'}>
                <FontAwesomeIcon icon={faCaretDown} />
            </div>

            {/* Tape content */}
            <div className={'tape-container'}>
                {/* ... to show that tape is infinite in both directions */}
                <div className={'tape-cell border border-dark border-1 border-start-0'}>
                    ...
                </div>

                {
                    adjustedTape.map((char, index) => (
                        <div className={(adjustedHighlightedCellIndex === index && needToHighlight) ?
                            'tape-cell border border-dark border-3 container-highlighted' :
                            'tape-cell border border-dark border-1'}
                             key={index}>
                            {char}
                        </div>
                    ))
                }

                <div className={'tape-cell border border-dark border-1 border-end-0'}>
                    ...
                </div>
            </div>
        </div>

    );
}